(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bb-subscription-packs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bb-subscription-packs')) {
  customElements.define('bb-subscription-packs', class extends HTMLElement {
    connectedCallback() {
      if (this.controller && !this.controller.signal.aborted) return;
      this.root = this.closest('product-page');
      if (!this.root) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.refresh = () => {
        const form = document.getElementById(this.dataset.formId);
        const variant = form?.querySelector('[name="id"]')?.value;
        const selected = Array.from(this.root.querySelectorAll('input[data-radio-type]:checked')).find(input => input.closest('[data-variant-id]')?.dataset.variantId === variant);
        const section = this.root.querySelector('.shopify_subscriptions_app_block[data-variant-id="' + variant + '"]');
        const heading = section?.querySelector('.group_name');
        if (heading && heading.nextElementSibling !== this) heading.after(this);
        this.hidden = !heading;
        const subscribed = selected?.dataset.radioType === 'selling_plan';
        this.root.classList.toggle('bb-subscription-packs-active', subscribed);
        section?.classList.add('bb-subscription-packs-widget');
        const quantity = Number(form?.querySelector('[name="quantity"]')?.value || 1);
        this.root.classList.toggle('bb-subscription-packs-fixed', subscribed && [1, 2, 4].includes(quantity));
        this.querySelectorAll('[data-pack-quantity]').forEach(button => button.setAttribute('aria-pressed', String(subscribed && Number(button.dataset.packQuantity) === quantity)));
      };
      this.root.addEventListener('change', () => queueMicrotask(this.refresh), options);
      this.root.addEventListener('input', this.refresh, options);
      this.root.addEventListener('click', () => queueMicrotask(this.refresh), options);
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-pack-quantity]');
        if (!button) return;
        const form = document.getElementById(this.dataset.formId);
        if (!form) return;
        const variant = form.querySelector('[name="id"]')?.value;
        const section = this.root.querySelector('.shopify_subscriptions_app_block[data-variant-id="' + variant + '"]');
        const plan = section?.querySelector('input[data-radio-type="selling_plan"]:checked') || section?.querySelector('input[data-radio-type="selling_plan"]');
        if (!plan) return;
        if (!plan.checked) plan.click();
        let input = form.querySelector('[name="quantity"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'quantity';
          form.append(input);
        }
        input.value = button.dataset.packQuantity;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        this.refresh();
      }, options);
      this.observer = new MutationObserver(this.refresh);
      this.observer.observe(this.root, { childList:true, subtree:true, attributes:true, attributeFilter:['value','checked'] });
      this.refresh();
    }
    disconnectedCallback() {
      queueMicrotask(() => {
        if (this.isConnected) return;
        this.controller?.abort();
        this.observer?.disconnect();
        this.root?.classList.remove('bb-subscription-packs-active', 'bb-subscription-packs-fixed');
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
